export default class PartnerListFilter {
    selector = ''

    constructor(selector) {
        this.selector = selector
    }

    init() {
        let partnerLists = document.querySelectorAll(this.selector)
        partnerLists.forEach(partnerList => {
            let id = partnerList.getAttribute('data-id')
            if (id) {
                let select = document.getElementById('partner_categories-' + id)
                if (select) {
                    select.addEventListener('change', function() {
                        var category = this.value
                        if (category) {
                            let partnerColumns = document.querySelectorAll('#partner-' + id + ' .partner-column')
                            partnerColumns.forEach(function(column) {
                                if (!column.classList.contains(category)) {
                                    column.style.display = 'none'
                                } else {
                                    column.style.display = 'block'
                                }
                            })
                            let partnerGroups = document.querySelectorAll('#partner-' + id + ' .key-row .all')
                            partnerGroups.forEach(function(group) {
                                if (!group.classList.contains(category)) {
                                    group.style.display = 'none'
                                } else {
                                    group.style.display = 'block'
                                }
                            })
                        }
                    })
                }
            }
        })
    }
}